import * as React from 'react';
import { stylesheetSingleton } from './singleton';
/**
 * creates a hook to control style singleton
 * @see {@link styleSingleton} for a safer component version
 * @example
 * ```tsx
 * const useStyle = styleHookSingleton();
 * ///
 * useStyle('body { overflow: hidden}');
 */
export var styleHookSingleton = function () {
    var sheet = stylesheetSingleton();
    return function (styles, isDynamic) {
        React.useEffect(function () {
            sheet.add(styles);
            return function () {
                sheet.remove();
            };
        }, [styles && isDynamic]);
    };
};



//////////////////
// WEBPACK FOOTER
// ./~/react-style-singleton/dist/es2015/hook.js
// module id = 1484
// module chunks = 2